<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="showCost">
            <div class="col-12 col-md-6">
                <div :class="['form-field form-field--currency',{'form-field--error':$v.formData.benefit.cost.$error}]">
                    <label for="cost">{{ formLabels.fields.benefitCost }}</label>
                    <span>£</span><input v-model="formData.benefit.cost" id="cost" step="0.01" min="0.01" max="243" @focusout="formatCost" type="number" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.benefit && formTooltips.benefit.fields.benefitCost" v-tooltip="formTooltips.benefit.fields.benefitCost">?</span>
                    <span class="form-field__error" v-if="$v.formData.benefit.cost.$error && !$v.formData.benefit.cost.required">This field is required</span>
                    <span class="form-field__error" v-else-if="$v.formData.benefit.cost.$error">This field is invalid</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        },
        formTooltips: {
            type: Object
        }
    },
    inject: ['$v'],
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        benefitFields() {
            return this.formSummary[1].fields;
        },
        showCost() {
            return this.formData.benefit.action && this.formData.benefit.action === this.formLabels.fields.benefitAction1
        }
    },
    mounted() {
        this.formSummary.push({
            fields: {}
        });
    },
    watch: {
        'formData.benefit.action': {
            handler: function(newVal) {

                if(this.formData.benefit.reason) {
                    this.formData.benefit.reason = undefined;
                    // this.formSummary[1].fields['Reason for ammendment/cancelation'] = undefined;
                }
            }
        },
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        }
    },
    methods: {
        setConditionals() {
            // Here we set the conditionals for this field group, we need to store the full object paths for use in the core form
            // We also need to make sure we defined date, either with a condition or just returning false, as otherwise the form conditions will not set
            this.formConditionals.benefitCost = function() { return this.formData.benefit.action && this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction1 };
        },
        formatCost() {
            let cost = this.formData.benefit.cost;

            if(cost > 243) {
                this.formData.benefit.cost = Number.parseInt(243).toFixed(0);
            } else if(cost <= 0) {
                this.formData.benefit.cost = 0.01;
            } else {
                this.formData.benefit.cost = Number.parseFloat(cost).toFixed(2);
            }
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    action: 'Voucher action',
                    reason: 'Reason for ammendment/cancelation',
                    cost: 'New voucher amount'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }
        }
    },
    mounted() {
        this.setConditionals();

        this.formSummary.push({
            fields: {}
        });
    } 
}
</script>